import React from 'react';
import {Theme as MuiTheme, ThemeProvider as MuiThemeProvider} from '@material-ui/core/styles';
import {getMuiV4Theme} from 'utils/css/themeUtils';
export {createStyles, makeStyles, useTheme, withStyles} from '@material-ui/core/styles';

/**
 * @deprecated
 */
export type Theme = MuiTheme;

interface ThemeProviderProps {
  readonly children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({children}) => (
  <MuiThemeProvider theme={getMuiV4Theme()}>{children}</MuiThemeProvider>
);
